module.exports = __webpack_public_path__ + "static/media/soccer_ball.0de73cf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soccer_ball.png
// module id = 467
// module chunks = 7